import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-close.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const CloseIcon = createSvgIcon(<Icon />, 'CloseIcon');
